export const SET_AUTH = "SET_AUTH";
export const SET_RELEASE_STATE = "SET_RELEASE_STATE";
